// 말소 셸 더보기 (≤768 페이지) — 카드1 회사/사용자 · 카드2 수거 주소·언어·이용 안내·(대표) 전체 화면 전환 · 카드3 오류 신고·로그아웃.
// SimpleMore.js 구조 복제. 데스크톱은 회사명 메뉴(parts/MalsoWhoMenu.js)가 같은 행을 흡수한다.
// 대행사(listMalsoClients isBroker)만 수거 주소 다음에 '거래처' 행 → /main/m/clients. 실패·비대행사 = 행 없음.
// props: { user, onLogout, showToast }
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { T, R, FONT } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import { openBugReport } from '../../../components/BugReportButton';
import { canOfferMalso } from '../../simple/screenMode';
import SimpleCard from '../../simple/parts/SimpleCard';
import ConfirmSheet from '../../simple/parts/ConfirmSheet';
import Glyph from '../../simple/parts/Glyph';
import LangSelect from '../../simple/parts/LangSelect';
import LtrText from '../../simple/parts/LtrText';
import { logoutSimple } from '../../simple/moreActions';
import { switchToFull } from '../moreActions';
import PickupAddressSheet from '../parts/PickupAddressSheet';
import { listMalsoClients } from '../api';

var page = { display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 720, margin: '0 auto' };
var title = { fontSize: 19, fontWeight: 800, letterSpacing: '-.35px', color: T.navy, marginBottom: 4 };
var row = { display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', borderBottom: '1px solid ' + T.bdSoft, minWidth: 0 };
var rowLast = Object.assign({}, row, { borderBottom: 0 });
var tx = { flex: 1, minWidth: 0 };
var t1 = { display: 'block', fontSize: 13, fontWeight: 700, color: T.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var t2 = { display: 'block', fontSize: 11.5, color: T.muted, marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var icon = { width: 32, height: 32, borderRadius: R.md, flex: 'none', display: 'grid', placeItems: 'center', color: T.card, fontSize: FONT.label, fontWeight: 800 };
var actionBtn = { border: 0, background: 'none', padding: 0, margin: 0, font: 'inherit', textAlign: 'start', cursor: 'pointer', width: '100%' };
var chev = { color: T.faint, flex: 'none', fontSize: 15, lineHeight: 1 };

function Row(props) {
  var inner = (<React.Fragment>
    <span style={Object.assign({}, icon, { background: props.tone || T.muted })}><Glyph id={props.glyph} /></span>
    <span style={tx}>
      <span style={t1}>{props.title}</span>
      {props.sub ? <span style={t2}>{props.sub}</span> : null}
    </span>
    {props.right}
    {props.onClick ? <span style={chev}>›</span> : null}
  </React.Fragment>);
  var style = props.last ? rowLast : row;
  if (!props.onClick) return <div style={style}>{inner}</div>;
  return <button type="button" style={Object.assign({}, actionBtn, style)} data-testid={props.testId} onClick={props.onClick}>{inner}</button>;
}

function MalsoMore(props) {
  var t = useT();
  var navigate = useNavigate();
  var user = props.user || {};
  var st = useState('');
  var sheet = st[0], setSheet = st[1];
  var offer = canOfferMalso(user);
  var stB = useState(false); var broker = stB[0], setBroker = stB[1];

  useEffect(function () {
    var alive = true;
    listMalsoClients().then(function (c) { if (alive) setBroker(!!(c && c.isBroker)); })
      .catch(function () { /* 비대행사 취급 — 행 없음 */ });
    return function () { alive = false; };
  }, [setBroker]);

  var companyName = user.companyNameEn || user.companyName || user.name || '';

  var goFull = function () { setSheet(''); switchToFull(navigate, props.showToast, t); };
  var doLogout = function () { setSheet(''); logoutSimple(props.onLogout, navigate); };

  return (<div style={page}>
    <h2 style={title}>{t('shellTabMore')}</h2>

    <SimpleCard>
      <Row tone={T.navy} glyph="building" title={<LtrText>{companyName}</LtrText>} sub={t('moreCompany')} />
      <Row tone={T.muted} glyph="user" title={<LtrText>{user.name || ''}</LtrText>} sub={t('moreProfile')} last />
    </SimpleCard>

    <SimpleCard>
      <Row tone={T.accent} glyph="pin" title={t('carCancelPickupSection')} testId="malso-more-pickup"
        onClick={function () { setSheet('pickup'); }} />
      {broker ? (<Row tone={T.accent} glyph="building" title={t('malsoModeBrokerClients')} testId="malso-more-clients"
        onClick={function () { navigate('/main/m/clients'); }} />) : null}
      <Row tone={T.accent} glyph="translate" title={t('settingsLanguage')} right={<LangSelect variant="row" />} />
      <Row tone={T.muted} glyph="help" title={t('malsoModeGuideTitle')} testId="malso-more-guide" last={!offer}
        onClick={function () { navigate('/main/m/guide'); }} />
      {offer ? (<Row tone={T.ink} glyph="apps" title={t('malsoModeSwitchToFull')} sub={t('simpleShowAllSub')} last
        testId="malso-more-full" onClick={function () { setSheet('full'); }} />) : null}
    </SimpleCard>

    <SimpleCard>
      <Row tone={T.danger} glyph="bug" title={t('moreBugReport')} testId="malso-more-bug"
        onClick={function () { openBugReport('form'); }} />
      <Row tone={T.muted} glyph="power" title={t('settingsProfileLogout')} last
        onClick={function () { setSheet('logout'); }} />
    </SimpleCard>

    {sheet === 'pickup' ? <PickupAddressSheet user={user} showToast={props.showToast} onClose={function () { setSheet(''); }} /> : null}
    <ConfirmSheet open={sheet === 'full'} title={t('malsoModeSheetToFullTitle')} sub={t('malsoModeSheetToFullBody')}
      hint={t('malsoModeSheetToFullHint')} confirmLabel={t('malsoModeSwitchToFull')} onConfirm={goFull}
      onClose={function () { setSheet(''); }} />
    <ConfirmSheet open={sheet === 'logout'} title={t('settingsProfileLogout')} sub={t('settingsProfileLogoutConfirmMessage')}
      confirmLabel={t('settingsProfileLogout')} onConfirm={doLogout} onClose={function () { setSheet(''); }} />
  </div>);
}

export default MalsoMore;
